<template>
	<div id="aside" class="col-3">
		<b-card bg-variant="white" class="forHeader posClient" body-class="cardBodyClass">
			<div slot="header" class="custom-card-header pos-card-header">
				<div class="row">
					<div class="col-4 d-flex align-items-start">
						<p class="mb-0" style="font-size: 0.875rem;">{{ posCurrentDate }}</p>
					</div>
					<div class="col-8 posSessionButtons">
						<div>
							<b-button size="sm" @click="showXReport()" variant="success" v-b-tooltip.hover title="X отчет">
								<strong style="font-size: 15px">
									<i class="fa fa-window-close"></i>
								</strong>
							</b-button>
							<b-button class="ml-2" @click="showZReport()" variant="danger" v-b-tooltip.hover title="Закрыть сеанс">
								<strong style="font-size: 15px">Z</strong>
							</b-button>
							<b-button class="ml-2" @click="logoutModal = !logoutModal" v-b-tooltip.hover title="Выйти">
								<strong style="font-size: 15px">
									<i class="fa fa-sign-out"></i>
								</strong>
							</b-button>
							<b-modal v-model="logoutModal" @ok="logout" ok-title="Да" cancel-title="Отмена">
								<h4>{{ $t('pos.response') }}?</h4>
							</b-modal>

							<b-modal
								v-model="returnComponentModal"
								size="lg"
								hide-footer
								hide-header
								:no-close-on-esc="true"
								:no-close-on-backdrop="true"
							>
								<template>
									<return-component
										:mode="'retail'"
										:show-return-modal="returnComponentModal"
										@close="closeModalWindow('returnComponentModal')"
									></return-component>
								</template>
							</b-modal>

							<!--							<b-modal
															v-model="oneTimeDiscountModal"
															size="lg"
															hide-footer
															hide-header
														>
															<template>
																<table class="table table-striped" id="whDocTable">
																	<thead>
																	<tr>
																		<th class="p-1"> {{ $t("incomeFilter.regNo")}}</th>
																		<th class="p-1"> {{ $t("inventory.startDate")}}</th>
																		<th class="p-1"> {{ $t("inventory.finishDate")}}</th>
																		<th class="p-1"> </th>

																	</tr>
																	</thead>
																	<tbody>
																	<tr v-for="(item,index) in disocuntItems">
																		<td class="p-1">
																			{{item.regNumber}}
																		</td>
																		<td class="p-1">
																			{{item.startDiscountDate}}
																		</td>
																		<td class="p-1">
																			{{item.endDiscountDate}}
																		</td>
																		<td align="center" class="p-1">
																			<b-button
																				@click="closeOneTimeDiscountModal(item)"
																				variant="light">
																				<i class="fas fa-upload"></i>
																			</b-button>
																		</td>
																	</tr>
																	</tbody>
																</table>

															</template>
														</b-modal>-->

						</div>
					</div>
				</div>
			</div>

			<!-- <b-form-select v-model="savdoType" size="sm" v-if="isManager">
					  <option value="isDona">Розница</option>
					  <option value="isOptom">Оптом</option>
			</b-form-select> -->
			<!-- <p class="clientTitle">
				{{getFromModalMemberCard.firstName}} {{getFromModalMemberCard.lastName}}
				{{getFromModalMemberCard.middleName}}
			</p> -->

			<!-- <b-modal size="lg" hide-footer v-model="childModal">
				<ChooseClient
					v-if="childModal"
					:current-index="clientIndex"
					@close="closeClientTable"
					@resetCurrentIndex="resetCurrentIndex"
				></ChooseClient>
			</b-modal> -->

			<b-button
				variant="light"
				@click="openOneTimeDiscountModal"
			>{{ $t('promo-to-product.discount') }}
				<b-badge
					:pill="true"
					variant="warning">
					{{ countOfOneTimeDiscount }}
				</b-badge>
			</b-button>

			<div v-if="savdoType === 'isOptom'">
				<p class="text-danger" v-if="selectContrAgent">Пожалуйста выберите контрагента</p>
				<b-form-group class="mb-2" size="sm">
					<b-input-group class="shodowed-group">
						<b-form-select
							@change="categoryFilterChanged"
							:options="categoryOptions.items"
							:value-field="'id'"
							:text-field="'name'"
							v-model="categoryOptions.value"
							size="sm"
							id="categoryFilter"
						>
							<template slot="first">
								<option :value="null" disabled>-- {{ $t('contragent.search-category') }} --</option>
							</template>
						</b-form-select>
						<b-input-group-append>
							<b-input-group-addon>
								<b-button
									type="button"
									size="sm"
									variant="outline-default"
									@click="clearCategoryFilter"
									v-b-tooltip.hover
									:title="$t('contragent.clear')"
								>
									<i class="fa fa-close"></i>
								</b-button>
							</b-input-group-addon>
						</b-input-group-append>
					</b-input-group>
				</b-form-group>
				<multiselect
					v-model="contrAgent"
					:options="getContragentsForPos"
					track-by="id"
					:show-labels="false"
					:allow-empty="true"
					:loading="contragentsLoading"
					label="fullName"
					placeholder="-- Выберите контрагента --"
					class="multiselect-pricing"
				></multiselect>
			</div>
			<div v-if="savdoType === 'isDona'">
				<!-- <label style="font-size: 12px;" class="lebeltop">{{$t('client.addClient')}}</label>
				<div class="row top mt-3">
					<div class="col-6">
						<b-button
							class="saveButton"
							@click="openCreate()"
							variant="outline-primary"
							size="sm"
							block
						>
							<i
								class="fa fa-user-plus"
								style="font-size: 1.2em; color: rgb(55, 116, 177);margin-right: 13px"
							></i>
							{{$t('client.newClient')}}
						</b-button>
					</div>
					<div class="col-6">
						<b-button
							class="saveButton"
							type="filled"
							@click="clickOpen"
							variant="outline-primary"
							size="sm"
							block
						>
							<i class="fa fa-id-card fa-lg" style="margin-right: 13px" aria-hidden="true"></i>
							{{$t('client.scanner')}}
						</b-button>
					</div>
				</div> -->
				<div class="clientForPosMultiselect">
					<label for="positiomSeller">{{ $t('pos.saller') }}</label>
					<multiselect
						id="positiomSeller"
						v-model="seller"
						:options="getSellers"
						@select="sellerSelected"
						@remove="resetSeller"
						placeholder="--Выберите продавца--"
						:custom-label="sellerCustomLabel"
						label="firstName"
						@search-change="fetchSeller($event)"
						track-by="id"
						:show-labels="false"
					>
						<template slot="option" slot-scope="option">
							<!--						{{ option.option.firstName }} {{option.option.lastName}} - "{{ option.option.departmentName }}"-->
							{{ sellerCustomLabel(option.option) }}
						</template>
					</multiselect>

					<b-input-group>
						<template #prepend>
							<b-input-group-text>Полет</b-input-group-text>
						</template>
						<b-form-input
							v-model="flight"
						></b-form-input>
						<b-input-group-append>
							<b-button @click="keyboardModalTrue('flight')">
								<i class="fa fa-keyboard-o"/>
							</b-button>
						</b-input-group-append>
					</b-input-group>
					<b-input-group style="margin-top: 8px">
						<template #prepend>
							<b-input-group-text>Билет</b-input-group-text>
						</template>
						<b-form-input
							v-model="ticket"
						></b-form-input>
						<b-input-group-append>
							<b-button @click="keyboardModalTrue('ticket')">
								<i class="fa fa-keyboard-o"/>
							</b-button>
						</b-input-group-append>
					</b-input-group>
				</div>
			</div>

			<!--   Keyboard   -->
			<b-modal v-model="keyboardModal" centered title="Keyboard" hide-footer size="lg">
				<div style="border: 3px solid #97a0b3; padding: 10px; border-bottom: white">
					<b-input-group v-if="keyboardModel === 'ticket'">
						<template #prepend>
							<b-input-group-text>Ticket</b-input-group-text>
						</template>
						<b-form-input
							v-model="ticket"
						></b-form-input>
					</b-input-group>
					<b-input-group v-else-if="keyboardModel === 'flight'">
						<template #prepend>
							<b-input-group-text>Flight</b-input-group-text>
						</template>
						<b-form-input
							v-model="flight"
						></b-form-input>
					</b-input-group>
				</div>
				<div style="border: 3px solid #97a0b3; padding: 10px">
					<b-row class="px-3">
						<b-col align="center">
							<b-button @click="keyboardInsert('1')" class="mx-2" variant="outline-primary" pill>1</b-button>
							<b-button @click="keyboardInsert('2')" class="mx-2" variant="outline-primary" pill>2</b-button>
							<b-button @click="keyboardInsert('3')" class="mx-2" variant="outline-primary" pill>3</b-button>
							<b-button @click="keyboardInsert('4')" class="mx-2" variant="outline-primary" pill>4</b-button>
							<b-button @click="keyboardInsert('5')" class="mx-2" variant="outline-primary" pill>5</b-button>
							<b-button @click="keyboardInsert('6')" class="mx-2" variant="outline-primary" pill>6</b-button>
							<b-button @click="keyboardInsert('7')" class="mx-2" variant="outline-primary" pill>7</b-button>
							<b-button @click="keyboardInsert('8')" class="mx-2" variant="outline-primary" pill>8</b-button>
							<b-button @click="keyboardInsert('9')" class="mx-2" variant="outline-primary" pill>9</b-button>
							<b-button @click="keyboardInsert('0')" class="mx-2" variant="outline-primary" pill>0</b-button>
							<b-button @click="keyboardTrash()" class="mx-2" variant="outline-primary" pill><=</b-button>
						</b-col>
					</b-row>
					<b-row class="px-3 mt-2">
						<b-col v-if="shift" align="center">
							<b-button @click="keyboardInsert('Q')" class="mx-2" variant="outline-primary" pill>Q</b-button>
							<b-button @click="keyboardInsert('W')" class="mx-2" variant="outline-primary" pill>W</b-button>
							<b-button @click="keyboardInsert('E')" class="mx-2" variant="outline-primary" pill>E</b-button>
							<b-button @click="keyboardInsert('R')" class="mx-2" variant="outline-primary" pill>R</b-button>
							<b-button @click="keyboardInsert('T')" class="mx-2" variant="outline-primary" pill>T</b-button>
							<b-button @click="keyboardInsert('Y')" class="mx-2" variant="outline-primary" pill>Y</b-button>
							<b-button @click="keyboardInsert('U')" class="mx-2" variant="outline-primary" pill>U</b-button>
							<b-button @click="keyboardInsert('I')" class="mx-2-2" variant="outline-primary" pill>I</b-button>
							<b-button @click="keyboardInsert('O')" class="mx-2" variant="outline-primary" pill>O</b-button>
							<b-button @click="keyboardInsert('P')" class="mx-2" variant="outline-primary" pill>P</b-button>
							<b-button @click="keyboardModal = false" class="mx-2" variant="outline-primary" pill>Enter</b-button>
						</b-col>
						<b-col v-else align="center">
							<b-button @click="keyboardInsert('q')" class="mx-2" variant="outline-primary" pill>q</b-button>
							<b-button @click="keyboardInsert('w')" class="mx-2" variant="outline-primary" pill>w</b-button>
							<b-button @click="keyboardInsert('e')" class="mx-2" variant="outline-primary" pill>e</b-button>
							<b-button @click="keyboardInsert('r')" class="mx-2" variant="outline-primary" pill>r</b-button>
							<b-button @click="keyboardInsert('t')" class="mx-2" variant="outline-primary" pill>t</b-button>
							<b-button @click="keyboardInsert('y')" class="mx-2" variant="outline-primary" pill>y</b-button>
							<b-button @click="keyboardInsert('u')" class="mx-2" variant="outline-primary" pill>u</b-button>
							<b-button @click="keyboardInsert('i')" class="mx-2-2" variant="outline-primary" pill>i</b-button>
							<b-button @click="keyboardInsert('o')" class="mx-2" variant="outline-primary" pill>o</b-button>
							<b-button @click="keyboardInsert('p')" class="mx-2" variant="outline-primary" pill>p</b-button>
							<b-button @click="keyboardModal = false" class="mx-2" variant="outline-primary" pill>Enter</b-button>
						</b-col>
					</b-row>
					<b-row class="px-3 mt-2">
						<b-col v-if="shift" align="center">
							<b-button @click="keyboardInsert('A')" class="mx-2" variant="outline-primary" pill>A</b-button>
							<b-button @click="keyboardInsert('S')" class="mx-2" variant="outline-primary" pill>S</b-button>
							<b-button @click="keyboardInsert('D')" class="mx-2" variant="outline-primary" pill>D</b-button>
							<b-button @click="keyboardInsert('F')" class="mx-2" variant="outline-primary" pill>F</b-button>
							<b-button @click="keyboardInsert('G')" class="mx-2" variant="outline-primary" pill>G</b-button>
							<b-button @click="keyboardInsert('H')" class="mx-2" variant="outline-primary" pill>H</b-button>
							<b-button @click="keyboardInsert('J')" class="mx-2" variant="outline-primary" pill>J</b-button>
							<b-button @click="keyboardInsert('K')" class="mx-2" variant="outline-primary" pill>K</b-button>
							<b-button @click="keyboardInsert('L')" class="mx-2" variant="outline-primary" pill>L</b-button>
							<b-button class="mx-2" variant="outline-primary" pill @click="shift = false">Shift</b-button>
						</b-col>
						<b-col v-else align="center">
							<b-button @click="keyboardInsert('a')" class="mx-2" variant="outline-primary" pill>a</b-button>
							<b-button @click="keyboardInsert('s')" class="mx-2" variant="outline-primary" pill>s</b-button>
							<b-button @click="keyboardInsert('d')" class="mx-2" variant="outline-primary" pill>d</b-button>
							<b-button @click="keyboardInsert('f')" class="mx-2" variant="outline-primary" pill>f</b-button>
							<b-button @click="keyboardInsert('g')" class="mx-2" variant="outline-primary" pill>g</b-button>
							<b-button @click="keyboardInsert('h')" class="mx-2" variant="outline-primary" pill>h</b-button>
							<b-button @click="keyboardInsert('j')" class="mx-2" variant="outline-primary" pill>j</b-button>
							<b-button @click="keyboardInsert('k')" class="mx-2" variant="outline-primary" pill>k</b-button>
							<b-button @click="keyboardInsert('l')" class="mx-2" variant="outline-primary" pill>l</b-button>
							<b-button class="mx-2" variant="outline-primary" pill @click="shift = true">Shift</b-button>
						</b-col>
					</b-row>
					<b-row class="px-3 mt-2">
						<b-col v-if="shift" align="center">
							<b-button @click="keyboardInsert('Z')" class="mx-2" variant="outline-primary" pill>Z</b-button>
							<b-button @click="keyboardInsert('X')" class="mx-2" variant="outline-primary" pill>X</b-button>
							<b-button @click="keyboardInsert('C')" class="mx-2" variant="outline-primary" pill>C</b-button>
							<b-button @click="keyboardInsert('V')" class="mx-2" variant="outline-primary" pill>V</b-button>
							<b-button @click="keyboardInsert('B')" class="mx-2" variant="outline-primary" pill>B</b-button>
							<b-button @click="keyboardInsert('N')" class="mx-2" variant="outline-primary" pill>N</b-button>
							<b-button @click="keyboardInsert('M')" class="mx-2" variant="outline-primary" pill>M</b-button>
							<b-button @click="keyboardInsert(' ')" class="mx-2" variant="outline-primary" pill>___________</b-button>
							<b-button @click="keyboardInsert(',')" class="mx-2" variant="outline-primary" pill>,</b-button>
						</b-col>
						<b-col v-else align="center">
							<b-button @click="keyboardInsert('z')" class="mx-2" variant="outline-primary" pill>z</b-button>
							<b-button @click="keyboardInsert('x')" class="mx-2" variant="outline-primary" pill>x</b-button>
							<b-button @click="keyboardInsert('c')" class="mx-2" variant="outline-primary" pill>c</b-button>
							<b-button @click="keyboardInsert('v')" class="mx-2" variant="outline-primary" pill>v</b-button>
							<b-button @click="keyboardInsert('b')" class="mx-2" variant="outline-primary" pill>b</b-button>
							<b-button @click="keyboardInsert('n')" class="mx-2" variant="outline-primary" pill>n</b-button>
							<b-button @click="keyboardInsert('m')" class="mx-2" variant="outline-primary" pill>m</b-button>
							<b-button @click="keyboardInsert(' ')" class="mx-2" variant="outline-primary" pill>___________</b-button>
							<b-button @click="keyboardInsert('.')" class="mx-2" variant="outline-primary" pill>.</b-button>
						</b-col>
					</b-row>
				</div>
			</b-modal>

			<!-- VOZVRAT KNOPKA -->
			<div id="returnButtonDiv">
				<!--				<p v-if="isReturn" style="color: red;">{{$t('pos.return-title')}}</p>-->
				<!--				<b-button pill-->
				<!--						  v-b-tooltip.hover :title="isReturn ? 'Отключить режим возврата' : 'Включить режим возврата'"-->
				<!--						  :variant="isReturn ? 'danger' : 'outline-secondary'"-->
				<!--						  @click="toggleIsReturn(!isReturn)"-->
				<!--				>-->
				<!--					{{$t('pos.return')}}-->
				<!--				</b-button>-->
				<div id="returnComponentButton">
					<b-button pill v-b-tooltip.hover @click="openReturnComponentModal">{{ $t('pos.return') }}</b-button>
				</div>
			</div>
			<!-- VOZVRAT KNOPKA END -->

			<vs-sidebar
				position-right
				parent="body"
				default-index="1"
				color="primary"
				class="create-client-modal sidebar-for-client-mod`"
				spacer
				v-model="active"
			>
				<CLientMemberCard
					@closeMe="fuc"
					@saveSuccess="$emit('saveSuccess')"
					v-if="active"
					:current-index="clientIndex"
					@resetCurrentIndex="resetCurrentIndex"
				></CLientMemberCard>
				<div style="text-align: center;">
					<span style="color: red">{{ this.message }}</span>
				</div>
				<div style="text-align: center;margin-top: 30px">
					<span>{{ $t('client.please') }}</span>
				</div>
				<div style="display: flex;justify-content: center">
					<img style="height: 150px;" src="../../../public/img/avatars/card.png"/>
				</div>
			</vs-sidebar>

			<vs-sidebar
				:click-not-close="true"
				position-right
				parent="body"
				default-index="1"
				color="primary"
				class="create-client-modal sidebar-for-client-mod` al"
				spacer
				v-model="createModal"
			>
				<b-container index="1" v-if="createModal">
					<CreateClientModal @not-close="closable = $event" @close="close" :mode="mode"></CreateClientModal>
				</b-container>
			</vs-sidebar>
		</b-card>
		<div
			style="display: flex; min-height: 0%; transition: min-height .25s ease-out;"
			:class="transactionCollapsed ? 'takeMinHeight' : ''"
		>
			<b-card style="min-height: 100%; width: 100%; margin-bottom: 0;">
				<div
					style="display: flex;justify-content: space-between;cursor: pointer"
					@click="transactionCollapsed = !transactionCollapsed"
				>
					<span>{{ $t('pos.sale-prev') }}</span>
					<i
						v-if="transactionCollapsed"
						class="fa fa-minus"
						style="align-items: center;display: flex"
					></i>
					<i v-else class="fa fa-plus" style="align-items: center;display: flex"></i>
				</div>
				<b-collapse id="collapse-1" v-model="transactionCollapsed" class="mt-2">
					<!-- TEST  -->
					<b-tabs content-class="customTabContent" fill>
						<b-tab
							:title="$t('pos.sale-title')"
							title-link-class="customTabLink"
							active
							@click="onCLickDraft"
						>
							<b-table
								style="max-width: 400px ;white-space: nowrap"
								class="generalTableClass"
								:hover="hover"
								:striped="striped"
								:bordered="bordered"
								:small="small"
								:fixed="fixed"
								responsive="sm"
								:items="latestSuspends"
								:fields="computedFields"
								:per-page="0"
								show-empty
							>
								<!-- EMPTY SLOT FOR TABLE -->
								<template slot="empty" slot-scope="scope">
									<h6>{{ $t('empty') }}</h6>
								</template>
								<!-- EMPTY SLOT FOR TABLE -->
								<template slot="actions" slot-scope="data">
									<b-link
										style="font-size: 15px"
										class="text-danger ml-1 mr-1"
										:key="data.item.id + 'delete'"
										@click="onOpen(data.item.id)"
										:id="'popOverDelete'+data.item.id"
										v-if="$can('delete', 'sale')"
									>
										<i class="fa fa-trash"></i>
									</b-link>

									<b-link class="text-dark ml-1" style="font-size: 15px" @click="updateDraft(data.item)" v-b-tooltip.hover>
										<i class="fa fa-edit"></i>
									</b-link>

									<b-popover
										:key="data.item.id + 'popover'"
										:target="'popOverDelete'+data.item.id"
										placement="auto"
										container="myContainer"
										:ref="'popover'+data.item.id"
										class="refDeleteConfirm"
									>
										<template slot="title">
											<b-button
												@click="onClose(data.item.id)"
												class="close"
												aria-label="Close"
												style="margin-left: 5px"
											>
												<span class="d-inline-block" aria-hidden="true">&times;</span>
											</b-button>
											Вы уверены?
										</template>
										<div>
											<div class="row mt-1">
												<div class="col-6">
													<b-button
														variant="outline-danger"
														size="sm"
														block
														@click="onClose(data.item.id)"
													>{{ $t('actions.no') }}
													</b-button>
												</div>
												<div class="col-6">
													<b-button
														variant="outline-success"
														size="sm"
														block
														@click="onOk(data.item.id)"
													>{{ $t('actions.yes') }}
													</b-button>
												</div>
											</div>
										</div>
									</b-popover>
								</template>
							</b-table>
						</b-tab>
						<!--						<b-tab title="Tugallangan" title-link-class="customTabLink"><p>I'm the first tab</p></b-tab>-->
					</b-tabs>
				</b-collapse>
			</b-card>
		</div>
	</div>
</template>

<script>
import {mapActions, mapGetters, mapState} from "vuex";
import CreateClientModal from "./CreateClientModal";
import ChooseClient from "./ChooseClient";
import ClientTable from "./ClientTable";
import ClientForPos from "./ClientForPos";
import ClientService from "../../services/client.service";
import CLientMemberCard from "./ClientMemberCard";
import Multiselect from "vue-multiselect";
import ReturnComponent from "../../views/return-component/ReturnComponent";

export default {
	name: "ClientForPos",
	props: {
		countOfOneTimeDiscount: {
			type: Number,
			default: 0
		},
		caption: {
			type: String,
			default: "Employees"
		},
		hover: {
			type: Boolean,
			default: true
		},
		striped: {
			type: Boolean,
			default: true
		},
		bordered: {
			type: Boolean,
			default: false
		},
		small: {
			type: Boolean,
			default: false
		},
		fixed: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			shift: false,
			keyboardModal: false,
			keyboardModel: '',
			flight: '',
			ticket: '',
			transactionCollapsed: true,
			seller: null,
			posCurrentDate: "",
			clientIndex: 0,
			active: false,
			item: null,
			keyword: "",
			currentClientMess: "",
			createModal: false,
			logoutModal: false,
			message: "",
			mode: "create",
			closable: false,
			loading: false,
			unitName: "",
			clientCurrent: "",
			convert: true,
			param: "",
			clientName: "",
			errorMessage: null,
			suspendActive: false,
			savdoType: "isDona",
			contrAgent: [],
			selectContrAgent: false,
			newItem: {
				id: null,
				itemId: null,
				itemName: null,
				count: null
			},
			childModal: false,
			sampleForAttrId: {
				field: "category.id",
				value: "",
				type: "long",
				option: "EQUALS",
				orderBy: "desc"
			},
			categoryOptions: {
				items: [],
				value: null
			},
			contragentsLoading: false,
			groupOptions: {
				items: [],
				value: null
			},
			returnComponentModal: false,
			disocuntItems: {},
			oneTimeDiscountModal: false
		};
	},
	async mounted() {
		this.makeCurrentDateTime();
		await this.getAllSellers(this.keyword);
		this.$store.commit("clients/resetCurrentClient");
		this.getLatestSuspends();
		this.seller = this.getSellers.find(option => option.isUserEmployee);
		this.sellerSelected(this.seller)
		// this.getActiveDiscount()
	},
	/** --BEFORE DESTROY HOOK-- **/
	beforeDestroy() {
		this.resetParamForFilter();
	},
	methods: {
		...mapActions("contragents", [
			"fetchContragents",
			"setCurrentPage", // receives currentPage
			"setParamForFilter", // receives fieldObj
			"deleteParamFromFilter", // receives fieldName
			"resetParamForFilter", // receives nothing; just call and it resets the filter
			"deleteContragentStore",
			"createContragentStore",
			"changeFieldsForTable"
		]),
		...mapActions("references", ["getReferenceChildren"]),
		...mapActions("clients", [
			"getAllClients",
			"getClientWithId",
			"getAllSellers",
			"getMemberCardStore",
			"emptyObjectStore",
			"setCurrentClient",
			"emptyObjectClientSidebar"
		]),
		...mapActions("pos", [
			"getLatestSuspends",
			"deleteSuspendStore",
			"editForPosDraft"
		]),
		...mapActions(["logout"]),
		...mapActions("employees", ["getAllSellers"]),
		openReturnComponentModal() {
			this.returnComponentModal = true;
		},
		closeModalWindow(name) {
			this[name] = false;
		},
		keyboardModalTrue(model) {
			this.keyboardModel = model
			this.keyboardModal = true
		},
		keyboardInsert(key) {
			if (this.keyboardModel === 'ticket') {
				this.ticket += key
			} else if (this.keyboardModel === 'flight') {
				this.flight += key
			}
		},
		keyboardTrash() {
			if (this.keyboardModel === 'ticket') {
				this.ticket = this.ticket.substring(0, this.ticket.length-1)
			} else if (this.keyboardModel === 'flight') {
				this.flight = this.flight.substring(0, this.flight.length-1)
			}
		},
		sellerSelected(seller) {
			this.$store.commit(
				"pos/setSellerName",
				seller.firstName + " " + seller.lastName
			);
			this.$store.commit("pos/setSellerId", seller.id);
		},
		resetSeller() {
			this.$store.commit("pos/setSellerName", "");
		},
		sellerCustomLabel(seller) {
			return (
				seller.firstName +
				" " +
				seller.lastName +
				' - "' +
				seller.departmentName +
				'"'
			);
		},
		fetchSeller(keyword) {
			this.getAllSellers(keyword);
		},
		resetCurrentIndex() {
			this.clientIndex = 0;
		},
		onClose(itemId) {
			let refName = "popover" + itemId;
			this.$refs[refName].$emit("close");
		},
		onOpen(itemId) {
			let refName = "popover" + itemId;
			this.$refs[refName].$emit("open");
		},
		async onOk(itemId) {
			this.onClose(itemId);
			await this.deleteSuspendStore(itemId);
			await this.getLatestSuspends();
			if (this.currentSuspendId == itemId) {
				this.$emit("changeSuspendActive", false);
				this.$emit("searchBarFocus");
				this.$store.commit("pos/resetState");
				this.$store.commit("pos/resetSuspendId");
			}
		},
		async closeClientTable(boolean, index) {
			const emptyObject = {};
			await this.emptyObjectStore(emptyObject);
			// this.$store.commit('clients/setCurrentClient');
			this.childModal = boolean;
			this.clientIndex = index;
			await this.$emit("searchBarFocus");
		},
		openCreate() {
			this.createModal = true;
		},
		showZReport() {
			this.$emit("showZReport");
		},
		showXReport() {
			this.$emit("showXReport");
		},
		onCLickDraft() {
			this.getLatestSuspends();
		},
		async updateDraft(data) {
			await this.editForPosDraft(data);
			this.flight = data.flight1
			this.ticket = data.ticket1
			if (data.customerId) {
				await this.getClientWithId(data.customerId);
			} else {
				const emptyObject = {};
				await this.emptyObjectStore(emptyObject);
			}
			//				this.clientName = data.customerName;
			//				this.$store.commit('clients/resetCurrentClient');
			// Fire.$emit('activeEmit', {suspendActive: true, message: "Bu edit uchun"});
			await this.$emit("changeSuspendActive", true);
			await this.$emit("searchBarFocus");
			if (data.customPromotionDiscount) {
				let obj = {
					obj: {
						discount: data.customPromotionDiscount,
						promotionType: data.customPromotionType
					}
				};
				//  await this.$emit('editSuspend', obj);
				this.$store.commit("pos/setCustomPromotionGeneral", obj);
				// setCustomPromotionForItem(obj)
			} else {
				return false;
			}
		},

		fuc(event) {
			if (event.active == true) {
				this.active = true;
				this.message = event.message;
			} else {
				const emptyObject = {};
				this.message = event.message;
				this.active = false;

				//					this.emptyObjectClientSidebar(emptyObject);
			}
		},

		filterClientChanged(newVal) {
			ClientService.searchMember(newVal).then(response => {
				this.items = response.data;
			});
		},

		// getActiveDiscount() {
		// 	WarehouseService.getActiveDiscount(TokenService.getDepartmentId()).then(response => {
		// 		this.disocuntItems = response.data
		// 		this.countOfOneTimeDiscount = this.disocuntItems.length
		// 	});
		// },
		openOneTimeDiscountModal() {
			// this.oneTimeDiscountModal = true
			this.$emit('oneTimeDiscountClicked')
		},
		closeOneTimeDiscountModal(item) {
			this.oneTimeDiscountModal = false
		},

		clickOpen() {
			setTimeout(() => {
				this.active = true;
				this.message = "";
			}, 200);
		},
		close() {
			this.createModal = false;
			this.mode = "create";
			this.item = null;
		},
		makeCurrentDateTime() {
			let now = new Date();
			let year = now.getFullYear();
			let month = now.getMonth() + 1;
			let day = now.getDate();
			let hour = now.getHours();
			let minute = now.getMinutes();
			let second = now.getSeconds();
			if (month.toString().length == 1) {
				month = "0" + month;
			}
			if (day.toString().length == 1) {
				day = "0" + day;
			}
			if (hour.toString().length == 1) {
				hour = "0" + hour;
			}
			if (minute.toString().length == 1) {
				minute = "0" + minute;
			}
			if (second.toString().length == 1) {
				second = "0" + second;
			}

			this.posCurrentDate = day + "/" + month + "/" + year;
		},
		toggleIsReturn(boolean) {
			this.$store.commit("pos/setIsReturn", boolean);
			this.$emit("searchBarFocus");
		},
		async sendObjectToParent() {
			let obj = {};
			obj.type = this.savdoType;

			/** -- CLEAR CLIENT -- **/
			await this.$store.commit("clients/resetCurrentClient");

			/** -- CLEAR SELLER -- **/

			// this.seller = null;
			this.resetSeller();

			/** -- CLEAR CUSTOM_PROMOTION -- **/
			await this.$store.commit("pos/setCustomPromotionGeneral", {obj: null});
			if (this.savdoType === "isOptom") {
				if (
					this.contrAgent === null ||
					Object.keys(this.contrAgent).length === 0
				) {
					this.selectContrAgent = true;
					await this.$emit("savdoTypeChanged", obj);
				} else {
					obj.cont = this.contrAgent;
					await this.$emit("savdoTypeChanged", obj);
				}
				if (!this.categoryOptions.value) {
					await this.getReferenceChildren("CONTRAGENT_CATEGORY");
					this.categoryOptions = Object.assign({}, this.getCategoryChildren);
				}
			} else {
				this.contrAgent = null;
				await this.$emit("savdoTypeChanged", obj);
			}
		},
		/* CATEGORY FILTER FUNC */
		async categoryFilterChanged(categoryId) {
			let fieldName = "category.id";
			if (categoryId) {
				this.sampleForAttrId.field = fieldName;
				this.sampleForAttrId.value = categoryId;

				this.deleteParamFromFilter(fieldName);
				let fieldObj = Object.assign({}, this.sampleForAttrId);
				this.setParamForFilter(fieldObj);
			} else {
				if (!this.groupOptions.value) {
					this.resetParamForFilter();
				} else {
					this.deleteParamFromFilter(fieldName);
				}
			}
			// GET FILTERED DATA
			this.contragentsLoading = true;
			await this.fetchContragents("pos");
			this.contragentsLoading = false;
		},
		/* CLEARING FILTER */
		clearCategoryFilter() {
			this.categoryOptions.value = null;
		}
	},
	computed: {
		...mapGetters("clients", [
			"getClients",
			"total",
			"clients",
			"getFromModalMemberCard",
			"getCurrentClient"
		]),
		...mapGetters("employees", ["getSellers"]),
		...mapGetters("references", ["getCategoryChildren"]),
		...mapState("pos", [
			"latestSuspends",
			"currentSuspendId",
			"client",
			"isReturn",
			"shopId"
		]),
		...mapState("contragents", ["contragents"]),
		...mapGetters("contragents", ["getContragentsForPos"]),
		...mapState(["isCashier", "isManager"]),
		computedSeller() {
			return this.getSellers.map(e => {
				let tmp = e;
				tmp = e.isUserEmployee
				return tmp
			})
		}, computedFields() {
			return [
				// {
				// 	key: "id",
				// 	label: "№",
				// 	class: "min-30",
				// },
				{
					key: "saleNumber",
					label: this.$t("sidebar.pos.check"),
					class: "min-100"
				},
				{
					key: "saleDate",
					label: this.$t("pos.date"),
					class: "min-130 fixed"
				},
				// {
				// 	key: 'middleName',
				// 	label: this.$t('client.create.middle-name')
				// },
				// {
				// 	key: 'memberCard',
				// 	label: "Member card"
				// },

				{
					key: "actions",
					label: ''
				}
			];
		}
	},
	watch: {
		savdoType: {
			handler(newValue) {
				if (newValue !== null) {
					this.sendObjectToParent();
				}
			}
		},
		contrAgent: {
			handler(newValue) {
				if (newValue !== null) {
					this.selectContrAgent = false;
					this.sendObjectToParent();
				} else {
					this.selectContrAgent = true;
					this.sendObjectToParent();
				}
			}
		},
		/* WATCHERS FOR FILTER BEGIN */
		"categoryOptions.value": {
			handler(newVal) {
				if (!newVal) {
					this.categoryFilterChanged(null);
				}
				this.contrAgent = null;
			}
		}
	},
	components: {
		CreateClientModal,
		ChooseClient,
		ClientTable,
		ClientForPos,
		CLientMemberCard,
		Multiselect,
		ReturnComponent
	}
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped lang="scss">
.header-sidebar {
	display: flex;
	align-items: center;
	justify-content: center;
	flex-direction: column;
	width: 100%;
}

.header-sidebar h4 {
	display: flex;
	align-items: center;
	justify-content: center;
	width: 100%;
}

.header-sidebar h4 > button {
	margin-left: 10px;
}

.footer-sidebar {
	display: flex;
	align-items: center;
	justify-content: space-between;
	width: 100%;
}

.row {
	margin-left: -18px;
}

.footer-sidebar > button {
	border: 0px solid rgba(0, 0, 0, 0) !important;
	border-left: 1px solid rgba(0, 0, 0, 0.07) !important;
	border-radius: 0px !important;
}

.clientForPosMultiselect {
	margin-top: 50px;
}

.forHeader {
	/*min-height: 337px;*/
	margin-bottom: 5px;
}

.forfooter {
	min-height: 133px;
}

.card-header .nav-tabs .nav-link {
	padding: 0px;
}

.tabs.mytabs .nav-tabs .nav-link.active {
	background-color: #aabbcc !important;
}

.card-body {
	padding: 10px;
}

.cardBodyClass {
	position: relative;

	#returnButtonDiv {
		position: absolute;
		bottom: 0;
		left: 0;
		right: 0;
		margin: 10px;

		button {
			width: 100%;
		}
	}
}

.card-header .nav-tabs .nav-link {
	padding: 0 0 0 0;
}

.generalTableClass {
	max-height: 9rem;
	overflow-y: scroll;
	overflow-x: scroll;
}

@media (min-width: 1620px) {
	.generalTableClass {
		max-height: 13rem;
	}
}

/*.mytabs {
		.nav-tabs {
			.nav-item {
				.nav-link.customTabLink {
					padding: 5px;
				}
			}
		}
	}*/
.customTabLink {
	padding: 5px;
}

.takeMinHeight {
	min-height: 39.1% !important;
	transition: min-height 0.25s ease-in !important;
}

.saveButton {
	justify-content: center;
	display: flex;
	align-items: center;
}

.posSessionButtons {
	display: flex;
	align-items: center;
	justify-content: flex-end;

	button {
		padding: 0 6px 1px;
		font-size: 12px;
		margin-right: 5px;
		line-height: 1.4;
	}
}

.clientTitle {
	font-weight: bold;
	font-size: 16px;
}
</style>
